import Backbone from 'backbone';
import _ from 'underscore';
import ComponentBase from 'components/_base/ComponentBase';
import Handlebars from 'handlebars-template-loader/runtime';
import JPRouteHelper from '../../helpers/JPRouteHelper';

const JPTransitGeneralInfo = ComponentBase.extend(
    {
        template: require('./jpTransitGeneralInfo.hbs'),

        componentClass: 'jp-transit-general',

        identifier: 'jp-transit-general',

        stepsShownPerRoute: 2,

        constructor(options) {
            options.identifier = this.identifier;
            ComponentBase.prototype.constructor.call(this, options);
            this.widget = options.widget;
            this.componentConstructorClass = options.componentConstructorClass;
            this.travelMode = options.properties.travelMode;
            this.route = options.properties.route;
        },

        initialize(options = {}) {
            this.loadHelpers();
            const route = this.normalizeTransitRoute(options.properties.route);
            this.templateConfig = _.extend(options, {
                componentClass: 'jp-transit-general',
                travelMode: options.properties.travelMode,
                route: route,
                stepsShownPerRoute: this.stepsShownPerRoute
            });
            Backbone.View.prototype.initialize.call(this, options);
            this.render();
        },
        normalizeTransitRoute(route) {
            let totalWalking = 0;
            route.steps.forEach(step => {
                if (step.travel_mode === 'WALKING') {
                    totalWalking += step.duration.value;
                }
            });
            return {
                departureTime: route.departure_time ? route.departure_time.text : '',
                arrivalTime: route.arrival_time ? route.arrival_time.text : '',
                time: route.duration.text,
                walkingTime: (totalWalking / 60).toFixed(0),
                steps: route.steps.map((step) => {
                    if (step.travel_mode === 'WALKING') {
                        return {
                            travelMode: step.travel_mode.toLowerCase()
                        }
                    } else {
                        return {
                            travelMode: step.travel_mode.toLowerCase(),
                            lineName: step.transit.line.short_name,
                            icon: step.transit.line.vehicle.local_icon,
                            color: step.transit.line.color
                        }
                    }
                })
            };
        },

        loadHelpers() {
            Handlebars.registerHelper('printStep', function () {
                return JPRouteHelper.printStep(arguments);
            });

            Handlebars.registerHelper('printDots', function () {
                return JPRouteHelper.printDots(arguments);
            });
        },
    }
);
export default JPTransitGeneralInfo;


// WEBPACK FOOTER //
// ./src/components/JPTransitGeneralInfo/JPTransitGeneralInfo.js